export interface NavMenuItem {
  id?: number;
  name?: string;
  uri?: string;
  collapsed_name?: string;
  icon?: string;
  children?: NavMenuItem[];
  [key: string]: unknown;
}

export interface TrendingItem {
  post_title: string;
  url: string;
}

export interface NavState {
  country: string;
  domain: string;
  path: string;
  sitenav: NavMenuItem[];
  trendingStrap: TrendingItem[];
  searchSuggestions: string[];
  navCustomItems: NavMenuItem[];
  membersProps: Record<string, unknown> | null;
  contentType: string;
  isPaidMarketingPage: boolean;
  isF1Enabled: boolean;
  isAuthorPage: boolean;
  bannerSlotHtml: string;
  welcomePopup?: WelcomePopupConfig;
}

export interface WelcomePopupConfig {
  enabled: boolean;
  creditScoreUrl: string;
  blacklistPaths: string[];
}

interface DataPayload {
  sitenav?: NavMenuItem[];
  reducedMenuIds?: number[];
  bannerSlot?: string;
  country?: string;
  domain?: string;
  path?: string;
  trendingStrap?: TrendingItem[];
  contentType?: string;
  isF1Enabled?: boolean;
  navCustomItems?: NavMenuItem[];
  searchSuggestions?: string[];
  showSearch?: string;
  isAuthorPage?: boolean;
  welcomePopup?: WelcomePopupConfig;
}

declare global {
  // window.membersPropsJson is emitted by the finder-theme mu-plugin
  // (inc/enviroment/index.php) — it is shared infra outside our control,
  // so we still read it from the window.
  interface Window {
    membersPropsJson?: string;
  }
}

function readDataIsland(): DataPayload {
  const el = document.getElementById('gn-data');
  if (!el?.textContent) return {};
  try {
    return JSON.parse(el.textContent) as DataPayload;
  } catch {
    return {};
  }
}

function readMembersProps(): Record<string, unknown> | null {
  const raw = window.membersPropsJson;
  if (typeof raw !== 'string' || raw === '') return null;
  try {
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function readWindowData(): NavState {
  const data = readDataIsland();
  const contentType = data.contentType ?? '';

  return {
    country: data.country ?? 'au',
    domain: data.domain ?? location.origin,
    path: data.path ?? location.pathname,
    sitenav: data.sitenav ?? [],
    trendingStrap: data.trendingStrap ?? [],
    searchSuggestions: data.searchSuggestions ?? [],
    navCustomItems: data.navCustomItems ?? [],
    membersProps: readMembersProps(),
    contentType,
    isPaidMarketingPage: contentType.includes('paid-marketing'),
    isF1Enabled: data.isF1Enabled === true,
    isAuthorPage: data.isAuthorPage === true,
    bannerSlotHtml: data.bannerSlot ?? '',
    welcomePopup: data.welcomePopup,
  };
}
